import React from "react";
import { useAuthDataContext } from "../../components/auth-provider";
import { Button, TextField, Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import { useStyles } from "./LoginPage";


export const SignInForm = () => {

  const classes = useStyles();

  const { onLogin, isLoading } = useAuthDataContext();

  const onFinish = (ev: any) => {

    ev.preventDefault();

    const { email, password } = ev.currentTarget.elements;

    var values = {
      email: email.value,
      password: password.value,
    };

    onLogin && onLogin(values.email, values.password);
  };

  return (
    <>
      <Typography component="h3" variant="h5">
        Login
      </Typography>

      <form className={classes.form} noValidate onSubmit={onFinish}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="E-mail"
          name="email"
          autoComplete="email"
          autoFocus />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label="Senha"
          type="password"
          id="password"
          autoComplete="current-password" />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          disabled={isLoading === true}
        >
          Entrar
          </Button>
        {isLoading === true && <LinearProgress />}

      </form>

    </>
  );
};
